<template>
  <footer class="project-footer" data-anim="footer">
    <div class="c-container">
      <router-link
        :to="`/${$store.state.lang}/${$store.state.lang === 'en' ? 'projects' : 'progetti'}/${data.url}`"
      >
        <p class="project-footer__eyelet">Next projext</p>
        <p class="project-footer__title">{{ data.name }}</p>
      </router-link>
      <div class="project-footer__line">
        <span>
          <span class="line__span"></span>
        </span>
        <router-link
          :to="`/${$store.state.lang}/${$store.state.lang === 'en' ? 'projects' : 'progetti'}/${data.url}`"
          class="project-footer__caption"
        >see now</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'ProjectFooter',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/colors';
@import '../style/variables';
@import '../style/functions';
@import '../style/mixins';

.project-footer {
  background-color: $color-text;
  color: $color-light;

  a {
    width: fit-content;
    color: $color-light;

    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-flow: column wrap;
    box-sizing: content-box;

    p {
      position: relative;
      display: block;
    }
  }

  .c-container {
    padding-bottom: 40px;
  }

  &__eyelet {
    margin-bottom: 20px;
    text-transform: uppercase;
    font-size: font-size(m);
    font-weight: bold;
  }

  &__title {
    color: transparent;
    -webkit-text-stroke: 1px $color-light;
    font-size: font-size(xxl-mobile);

    @include mq(ipadP) {
      -webkit-text-stroke: 2px $color-light;
      font-size: font-size(title);
    }
  }

  &__line {
    position: relative;
    width: 100%;

    display: flex;
    align-items: baseline;
    justify-content: space-between;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      width: 100%;

      .line__span {
        position: relative;
        height: 1px;
        background-color: $color-light;
      }
    }

    a {
      margin-left: 40px;
      white-space: nowrap;
    }
  }
}
</style>
